import Vue from 'vue';
import Vuex from 'vuex';
// 模块
import common from './modules/common';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    common, // 系统初始化
  }
});

export default store;



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = null
// module chunks = 